export default __webpack_public_path__ + "static/media/IMG_0420.ac466b4d.jpg";